export default function ChartMethodology({ methodology }) {
  return (
    <section className="soft-card p-6 sm:p-8">
      <p className="text-xs font-black uppercase tracking-[0.2em] text-blue-700">Methodology</p>
      <h2 className="mt-3 text-2xl font-black text-neutral-950">How the dataset is built</h2>
      <p className="mt-4 text-base leading-8 text-neutral-700">{methodology}</p>
    </section>
  );
}
